import { useState } from "react";
import { toast } from "react-toastify";
import { FormModal } from "../../components/form";
import { OutlineButton, PrimaryButton } from "../../components/Buttons";
import CustomSelect from "../../components/CustomSelect";

/**
 * Upload a CSV against a project. Not a Form-driven screen — parent owns the
 * file (multipart upload). We use FormModal for the shell and CustomSelect
 * directly for the project picker so it matches every other dropdown in the
 * app.
 */
function CsvUploadModal({ open, onClose, selectedCsvFile, onFileSelect, onUpload, projects }) {
    const [selectedProjectId, setSelectedProjectId] = useState("");

    const handleUpload = () => {
        if (!selectedProjectId) {
            toast.error("Please select a project.");
            return;
        }
        onUpload(selectedProjectId);
        onClose();
    };

    const projectOptions = (projects || []).map((p) => ({
        value: p.projectId,
        label: p.projectName,
    }));
    const selectedOption = projectOptions.find((o) => o.value === selectedProjectId) || null;

    return (
        <FormModal
            open={open}
            onClose={onClose}
            title="Upload CSV"
            size="sm"
            footer={
                <div className="flex justify-end gap-2">
                    <OutlineButton onClick={onClose}>Cancel</OutlineButton>
                    <PrimaryButton
                        onClick={handleUpload}
                        disabled={!selectedCsvFile || !selectedProjectId}
                    >
                        Upload
                    </PrimaryButton>
                </div>
            }
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-normal text-slate-500 mb-1">
                        CSV File <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="file"
                        accept=".csv"
                        onChange={onFileSelect}
                        className="block w-full text-sm text-slate-700 file:mr-3 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-flamingo-50 file:text-flamingo-700 hover:file:bg-flamingo-100"
                    />
                    {selectedCsvFile && (
                        <p className="mt-1 text-xs text-slate-500 truncate">✓ {selectedCsvFile.name}</p>
                    )}
                </div>

                <CustomSelect
                    label="Select Project"
                    required
                    placeholder="Select a project"
                    options={projectOptions}
                    value={selectedOption}
                    onChange={(opt) => setSelectedProjectId(opt?.value || "")}
                    styles={{}}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    size="form"
                />
            </div>
        </FormModal>
    );
}

export default CsvUploadModal;
